import { createStoreModule } from '../utils';

export default createStoreModule({
  name: 'codePackage',
  modelName: 'code_packages',
  crud: true,
  endpoint: '/v2/code_packages'
});
